import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateUser($id: String!, $data: updateUserInput!) {
    updateUser(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateUserRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateUserInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/update_user',
  async (
  params: {id: String;data: TYPES.UpdateUserInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateUser;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateUserSlice = createSlice({
  name: 'update_user',
  initialState: initialState,
  reducers: {
    updateUserClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateUserRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateUserRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateUserRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateUserClear } = updateUserSlice.actions;

export const updateUser = createSelector(
  (state: RootState) => state.user.updateUser.result,
  (state: RootState) => state.user.updateUser.error,
  (state: RootState) => state.user.updateUser.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateUserSlice.reducer;